import PortalIdParser from 'PortalIdParser';
import { SEARCH_REFERRER_STORAGE_KEY } from '../constants/globalSearch';
import { salesAnalyticsBasedCollections } from '../constants/templates';
const getBaseUrl = () => '/reports-list';
export const getRootUrl = () => `${getBaseUrl()}/${PortalIdParser.get()}`;
export const getTemplatesUrl = templateId => `/templates/${templateId}`;
export const getTemplatesPath = (collectionId, templateId) => {
  const basePath = `/templates/${collectionId}`;
  return templateId ? `${basePath}/${templateId}` : basePath;
};
export const getCollectionsPath = (collectionId, categoryId) => {
  const basePath = `/collections/${collectionId}`;
  return categoryId ? `${basePath}/${categoryId}` : basePath;
};
const PRESERVABLE_NON_FILTER_RELATED_QUERY_PARAMS = ['globalSearch',
// Keep Onboarding Tour related params to avoid interrupting the onboarding hand holding banner
'onboardingTourId', 'onboarding_referrer_task', 'onboarding_referrer_group', 'onboarding_referrer_source'];
export const getNonFilterRelatedParams = urlParamsObj => {
  return Object.fromEntries(Object.entries(urlParamsObj).filter(([key, __value]) => PRESERVABLE_NON_FILTER_RELATED_QUERY_PARAMS.includes(key)));
};
export const saveSearchReferrer = reportsListPath => window.sessionStorage.setItem(SEARCH_REFERRER_STORAGE_KEY, reportsListPath);
const rootPathTrackingName = 'my-reports';
export const getPageNameFromPath = reportsListPath => {
  const pathParts = reportsListPath.split('/');
  return pathParts.find(pathParam => salesAnalyticsBasedCollections.includes(pathParam)) || rootPathTrackingName;
};
export const encodeParentheses = str => {
  return str.replace(/\(/g, '%28').replace(/\)/g, '%29');
};
export const getContentAssistantSettingsPageURL = () => {
  const portalId = PortalIdParser.get();
  return `/ai-settings/${portalId}`;
};